var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0142822,
    y: 0.276955,
    width: 149.971,
    height: 149.971,
    rx: 74.9857,
    fill: "#11D500",
    fillOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5653,
    y: 30.8269,
    width: 88.8719,
    height: 88.8719,
    rx: 44.436,
    fill: "#11D500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1887 75.2627L71.2978 86.3718L89.813 64.1536",
    fill: "#11D500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1887 75.2627L71.2978 86.3718L89.813 64.1536",
    stroke: "white",
    strokeWidth: 4.92413,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.62c7e9dc27e99c6775c8616c4f762e7d.svg";
export { ForwardRef as ReactComponent };